import { Component, Input, OnInit, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import * as Objects from '@core/objects';

import { FilesListItemMenuClick } from '@core/components/files/lists/files-list-item-menu-click';
import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';
import { UrlService } from '@core/services/url/url.service';
import { AnnotationsService } from '@core/services/annotations/annotations.service';


@Component({
    selector: 'core-message-files',
    templateUrl: './message-files.component.html',
    styleUrls: ['./message-files.component.scss']
})
export class MessageFilesComponent implements OnInit, OnChanges{

    @Input() message: Objects.Message;
    @Input() canCreateNotes: boolean = true;
    @Input() notesActionText: string;
    @Input() notesActionStyle: string;
    @Input() prefixUrl: string = '';
    @Input() context: string;

    public selectedFile: Objects.File = null;
    public show: boolean = false;
    public notesCounter:  Array<Objects.AnnotationsCounter>;
    
    private counterUrlPrefix: string;
    public loadingCounter: boolean = false;

    public menu: Array<ThreeDotsMenuItem> = [
        {
            title: "Download File",
            key: "download",
            icon: "download"
        },
        {
            title: "See Notes",
            key: "notes",
            icon: "notes"
        },
        // {
        //     title: "Remove",
        //     key: "remove",
        //     icon: "remove"
        // },
    ];
    constructor(private urlSrv: UrlService,
        private cdr: ChangeDetectorRef,
        private annotationsSrv: AnnotationsService ){}

    ngOnInit(){
        this.loadNotes();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes.prefixUrl){
            this.loadNotes();
        }
    }

    notesSaved(notes: Array<Objects.Note>){
        // TODO: review if reload notes heeerrrre or not
        this.loadNotes();
    }

    openNotes(file: Objects.File) {
        if(this.selectedFile != null && this.selectedFile.id == file.id)
            this.selectedFile = null;
        else
            this.selectedFile = file;
    }

    toggleAttachments(){
        this.show = !this.show;
    }

    onMenuClick(menu: FilesListItemMenuClick) {
        switch(menu.key) {
            // case "remove":
            //     this.onClickDeactivate(menu.file);
            //     break;
            case "notes":
                this.openNotes(menu.file);
                break;
            case "download":
                window.location.href = this.urlSrv.build('/files/'+menu.file.id);
                break;
        }
    }

    onActionDownloadClick(file: Objects.File){
        window.location.href = this.urlSrv.build('/files/'+file.id);
    }

    // manage the ulr prefix here when message is known
    protected loadNotes() {
        if(this.message != null && this.message.files.length > 0){
            this.counterUrlPrefix = '/messages/'+this.message.id;
            
            if(this.canCreateNotes) {   
                this.menu[1].title = this.notesActionText;
            }
            // get the notes counter
            if(!this.loadingCounter){
                this.loadingCounter = true; // prevent multiple reloads when onchanges
                this.annotationsSrv.getCounter(this.counterUrlPrefix).subscribe({
                    next: (counter: Objects.AnnotationsCounter[]) => {
                        this.notesCounter = [...counter];
                        this.cdr.detectChanges(); // Force change detection
                        this.loadingCounter = false;
                    },
                    error: (error: HttpErrorResponse) => {
                        console.debug(" ERROR getting message notes counter:",error);
                        this.notesCounter = [];
                        this.loadingCounter = false;
                    }
                })
            }
        } else {
            this.notesCounter = [];
        }
    }

}
